export * from './MedWheelchairIcon';
export * from './MedWheelchairIcon16Light';
export * from './MedWheelchairIcon16Regular';
export * from './MedWheelchairIcon16Solid';
export * from './MedWheelchairIcon20Light';
export * from './MedWheelchairIcon20Regular';
export * from './MedWheelchairIcon20Solid';
export * from './MedWheelchairIcon24Regular';
export * from './MedWheelchairIcon24Solid';
export * from './MedWheelchairIcon32Regular';
export * from './MedWheelchairIcon64Regular';
